export default {
  namespaced: true,
  state: {
    winnerPlayers: [],
    looserPlayers: [],
    totals: [],
    points: 0,
    isDraw: 0,
  },
  getters: {
    winnerPlayers: state => {
      return state.winnerPlayers;
    },
    looserPlayers: state => {
      return state.looserPlayers;
    },
    points: state => {
      return state.points;
    },
    isDraw: state => {
      return state.isDraw;
    },
    scores: state => {
      return state.scores;
    },
    totals: state => {
      return state.totals;
    }
  },
  actions: {
  },
  mutations: {
    matchFinished(state, payload) {
      state.winnerPlayers = payload.winners;
      state.looserPlayers = payload.losers;
      state.points = payload.points;
      state.isDraw = payload.isDraw;
      state.totals = payload.totals;
      let i;
      var tableIndex = this.state.tables.tables.findIndex(
        (table) => table.id == this.state.tables.tableActiveId
      );
      this.state.tables.tables[tableIndex].users.forEach((player) => {
        player.scores = [];
        player.total = payload.totals[player.id];
      });
      for (i in payload.scores) {
        let score = payload.scores[i];
        this.state.tables.tables[tableIndex].users.map(player => player.id == score.user_id ? player.scores.push(score.score) : player);
      }
    },
    resetResults(state) {
      state.winnerPlayers = [];
      state.looserPlayers = [];
      state.points = 0;
      state.isDraw = false;
      state.totals = 0;
    }
  }
};
